import _ from 'lodash'

/*

settings : {
	menu: {
		picto: '',
		label: ''
	},
	sousmenu: {
 		list: [
 			{
 				picto: '',
				label: '',
				action: ''
				viewBox: '0 0 48 48',
				width: 18,
				height: 18
 			},
 			{
 				picto: '',
				label: '',
				action: ''
 			}
 		]
	}
}

*/

export default {
	data() {
		return {
			open: false,
			timestamp_opened: null
		}
	},
	props: ['settings', 'context'],
	mounted(){
		//AS--> Ajout un événement sur le body pour fermer la modale
		document.querySelector("body").addEventListener('click', this.close_modal);
	},
	beforeDestroy: function() {
		document.querySelector("body").removeEventListener('click', this.close_modal);
	},
	created(){
		
	},
	watch:{
		"$store.state.ui.menu_sous_menu_timestamp_opened": function(after, before){
			if(after == this.timestamp_opened){
				this.open = true
			}else{
				this.open = false
			}
		}
	},
	methods: {
		switch_modal(event) {
			if(this.open){
				this.close_modal()
			}else{
				this.open_modal()
			}
		},
		open_modal(){
			let time = new Date().getTime();
			this.timestamp_opened = time;
			this.$store.commit('UI_SET_MENU_SOUS_MENU_TIMESTAMP_OPENED', time)
		},
		close_modal() {
			this.open = false
		},
	},
	computed:{
		
	},
	components:{
		
	}
}